import { tw } from "@careinfo/tailwind";
import { Control, FieldValues, Path, useController } from "react-hook-form";

interface Props<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  label: string;
  rows?: number;
  placeholder?: string;
  autoFocus?: boolean;
  required?: boolean;
  disabled?: boolean;
}

export default function TextAreaField<T extends FieldValues>({
  control,
  name,
  label,
  rows = 6,
  placeholder = "Enter text here...",
  required = false,
  autoFocus = false,
  disabled = false,
}: Props<T>) {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  return (
    <label className={tw`w-full`}>
      <span className={tw`block  text-[#272727]`}>
        {label}{" "}
        {required && <span className={tw`text-red-600 text-xl`}>*</span>}
      </span>
      <textarea
        {...field}
        id={name}
        rows={rows}
        disabled={disabled}
        autoFocus={autoFocus}
        placeholder={placeholder}
        className={tw` bg-[#EFF4F4] focus:outline-none mt-2 p-2 w-full rounded-sm `}
      />
      {error && (
        <span
          className={tw`text-red-500 text-xs flex items-center gap-x-1 mt-2`}
        >
          <span className={tw`block`}>{error.message}</span>
        </span>
      )}
    </label>
  );
}
